import MyShop from "../assets/projects/Myshop.png";
import BookMyCar from "../assets/projects/BookMyCar.png";
import Caratlane from "../assets/projects/Caratlane.png";
import Trade from "../assets/Trade24.png";
import ElectroWorld from "../assets/projects/ElectroWorldImage.png";
import Saavn from "../assets/projects/SaavanMusicApp.png";
import Epesign from "../assets/jobs/Epesign-Logo.png";
import CodeReviewer from "../assets/projects/Code Reviewer.AI.png";
import Summarizer from "../assets/projects/Summarizer.AI.png";

export const data = [
  {
    id: 1,
    name: "Next JS Application",
    pName: "Code Reviewer.AI",
    pDesc:
      "Code Reviewer.AI connects to public and private Git repositories and automatically reviews pull requests using AI.",
    image: CodeReviewer,
    github: "https://github.com/Rinkesh375/Code-Reviewer.AI",
    live: "https://code-reviewer-ai-five.vercel.app/",
    tech: [
      { name: "#NextJS", color: "white" },
      { name: "#TailwindCSS", color: "cyan" },
      { name: "#shadcn/ui", color: "gray" },
      { name: "#TanStack", color: "orange" },
      { name: "#PostgreSQL", color: "blue" },
      { name: "#Prisma", color: "indigo" },
      { name: "#BetterAuth", color: "emerald" },
      { name: "#GitHub", color: "slate" },
      { name: "#OpenAI", color: "green" },
      { name: "#GeminiAI", color: "purple" },
      { name: "#GenerativeAI", color: "pink" },
    ],
  },
  {
    id: 2,
    name: "Next-Prisma Application",
    pName: "Summarizer.AI",
    pDesc:
      "Summarizer.AI is an AI-powered tool that transforms lengthy PDF documents into concise, readable summaries using Google and OpenAI APIs for accurate content understanding.",
    image: Summarizer,
    github: "https://github.com/Rinkesh375/Summarizer.AI",
    live: "https://summarizer-ai-green.vercel.app",
    tech: [
      { name: "#TypeScript", color: "blue" },
      { name: "#PostgreSQL", color: "sky" },
      { name: "#GeminiAPI", color: "violet" },
      { name: "#OpenAI", color: "emerald" },
      { name: "#ClerkAuth", color: "rose" },
      { name: "#LangChain", color: "amber" },
      { name: "#shadcn/ui", color: "gray" },
      { name: "#UploadThing", color: "indigo" },
      { name: "#TailwindCSS", color: "cyan" },
      { name: "#Stripe", color: "green" },
      { name: "#NextJS", color: "white" },
    ],
  },

  {
    id: 3,
    name: "React JS Application",
    pName: "MyShop",
    pDesc:
      "MyShop is a clone of Purplle. Purplle is an Indian e-commerce website which sells different variety of cosmetics products.",
    image: MyShop,
    github: "https://github.com/Rinkesh375/cut-note-8539",
    live: "https://my-shop-kohl.vercel.app/",
    tech: [
      { name: "#ReactJS", color: "red" },
      { name: "#Redux", color: "green" },
      { name: "#ChakraUi", color: "orange" },
      { name: "#json-server", color: "green" },
    ],
  },
  {
    id: 4,
    name: "React JS Application",
    image: ElectroWorld,
    pName: "Electro World",
    pDesc:
      "Electro-World is a thriving e-commerce website specializing in a wide range of electronic products, including mobile phones, laptops, televisions, and more",
    github: "https://github.com/Rinkesh375/Electro-world",
    live: "https://electro-world-delta.vercel.app/",
    tech: [
      { name: "#ReactJS", color: "red" },
      { name: "#Node js", color: "green" },
      { name: "#Mongo DB", color: "red" },
      { name: "#Express", color: "green" },
    ],
  },

  {
    id: 5,
    name: "React JS Application",
    image: Trade,
    pName: "Trade24",
    pDesc:
      "Trade24 is a clone of E*Trade.E*Trade is a Stock market website which sells variety of Stock",
    github: "https://github.com/Rinkesh375/Trade24",
    live: "https://trade24.vercel.app/",
    tech: [
      { name: "#ReactJS", color: "red" },
      { name: "#Node js", color: "green" },
      { name: "#Mongo DB", color: "red" },
      { name: "#Express", color: "green" },
    ],
  },
  {
    id: 6,
    name: "React JS Application",
    image: Saavn,
    pName: "Saavn Music",
    pDesc:
      "Saavn is a music app clone that offers users the opportunity to listen to a wide variety of songs.",
    github: "https://github.com/Rinkesh375/saavn-music-app",
    live: "https://saavn-music-app.vercel.app/",
    tech: [
      { name: "#JavaScript", color: "red" },
      { name: "#ReactJs", color: "green" },
      { name: "#TailwindCSS", color: "red" },
    ],
  },

  {
    id: 7,
    name: "JavaScript Application",
    image: Caratlane,
    pName: "JewelVibeHub",
    pDesc:
      "JewelVibeHub is a clone of Caratlane.Caratlane is a Indian e-commerce website which sells different variety of gold,silver jewellery.",
    github: "https://github.com/Rinkesh375/JewelVibeHub",
    live: "https://earnest-crostata-a31bdd.netlify.app/",
    tech: [
      { name: "#HTML", color: "red" },
      { name: "#CSS", color: "green" },
      { name: "#JavaScript", color: "red" },
      { name: "#json-server", color: "green" },
    ],
  },
  {
    id: 8,
    name: "JavaScript Application",
    image: BookMyCar,
    pName: "BookMyCar",
    pDesc:
      "BookMyCar is a clone of Zoomcar. Zoomcar is a website which provides different types of luxury car on rent.",
    github: "https://github.com/KamalPreet34/immense-year-34",
    live: "https://chipper-pegasus-8ad28c.netlify.app/",
    tech: [
      { name: "#HTML", color: "red" },
      { name: "#CSS", color: "green" },
      { name: "#JavaScript", color: "red" },
      { name: "#json-server", color: "green" },
    ],
  },
];

export const experienceData = [
  {
    title: "Full Stack Developer",
    date: "February 2024 - January 2026",
    company: "EPESIGN TECHNOLOGIES PRIVATE LIMITED",
    image: Epesign,
    work: [
      `Developed scalable and responsive full-stack applications using Next.js, NestJS, Node.js, MongoDB, Zustand, and Tailwind CSS.`,
      `Built frontend architecture from scratch with modular, DRY principles and advanced state management for long-term maintainability.`,
      `Improved application performance by reducing unnecessary API calls and re-renders using profiling, memoization, and optimized React hooks.`,
      `Enhanced web performance and best practices using Google Lighthouse audits, significantly improving page performance scores.`,
      `Designed and developed backend systems with a focus on scalability, clean architecture, and efficient data handling.`,
      `Optimized Elasticsearch indexing strategies to enable fast, efficient full-text search while reducing database load.`,
      `Implemented secure file storage using AWS S3 for images, Gerber files, and BOM files with proper access management.`,
      `Integrated authentication and role-based access control (RBAC) for admin, operator, and user workflows.`,
      `Enabled secure payment processing and real-time order tracking using Razorpay.`,
      `Integrated analytics and third-party APIs (Google Analytics, Zoho Books) to automate invoicing, track sales, and support data-driven product decisions.`,
    ],

    iconBg: "#FFFFFF",
  },
];
